var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockBottomRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 63,
    viewBox: "0 0 54 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2394 26.5056V35.2451H54.0039V26.5056H45.2394Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2355 44.2605V53H54V44.2605H45.2355Z",
    fill: "#FBE683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0011 19.9998V28.7393H53.7656V19.9998H45.0011Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41519 26.5076V35.2471H10.1797V26.5076H1.41519Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2394 9.02712V17.7666H54.0039V9.02712H45.2394Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4738 0.287866V9.02734H45.2383V0.287866H36.4738Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34652 17.7664V26.5059H1.41797V17.7664H-7.34652Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2355 -0.000220299V8.73926H54V-0.000220299H45.2355Z",
    fill: "#DDA4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7121 17.7664V26.5059H36.4766V17.7664H27.7121Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7121 48.8972V57.6367H36.4766V48.8972H27.7121Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1808 9.02712V17.7666H18.9453V9.02712H10.1808Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1808 0.287866V9.02734H18.9453V0.287866H10.1808Z",
    fill: "#218595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00113 17.9998V26.7393H9.76562V17.9998H1.00113Z",
    fill: "#F5D858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0011 10.9998V19.7393H36.7656V10.9998H28.0011Z",
    fill: "#8DA9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 63,
    fill: "white",
    transform: "matrix(-1 0 0 -1 54 63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockBottomRight);
export default __webpack_public_path__ + "static/media/block-bottom-right.2b775af60d27d2d30d0757e9091a6f38.svg";
export { ForwardRef as ReactComponent };